// Check that the input has exactly the right number of characters.
const exactStrLength = length => value =>
	value && value.length !== length ? `Must be ${length} characters` : undefined;

export default exactStrLength;
